export default "<p>inventory-main-detail-list works!</p>\r\n"